"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "albavilla": {
    "f34290fb": [{
      "hkey": "ffaeec44",
      "slug": "albavilla",
      "name": "Albavilla",
      "primary": true,
      "skipSearch": false
    }],
    "alpe-del-vicere": [{
      "hkey": "ffaeec44",
      "slug": "albavilla",
      "name": "Albavilla",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "59fcef89": [{
      "hkey": "ffaeec44",
      "slug": "albavilla",
      "name": "Albavilla",
      "primary": true,
      "skipSearch": false
    }],
    "carcano": [{
      "hkey": "ffaeec44",
      "slug": "albavilla",
      "name": "Albavilla",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;